export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5110.f4a75409.jpg";